export default __webpack_public_path__ + "static/media/town.560da65b.svg";